import { Box, Button, FormControlLabel, Grid, Radio, TextField, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { DynamicFormRef } from "../../../../components/dynamicFormRef"
import { ReportFolioProps, ReportFolioRef } from "./types"
import { useReportFoliosStyles } from "./reportFolioStyles"
import { BaseMenu } from "../../../../components"
import { DrawerEvidences } from "../../../../components/evidences"
import { DynamicFormRefProps, DynamicRefRef } from "../../../../components/dynamicFormRef/types"
import { ClickedBox } from "../clickedBox"
import { IOSSwitch } from "../../../../components/dinamicForm/switch"
import { Ref, createRef, forwardRef, useEffect, useImperativeHandle, useState } from "react"
import { EvidenceOptionType } from "../../../../hooks/evidences/typyng"

const ReportFolio = forwardRef((props: ReportFolioProps, ref: Ref<ReportFolioRef>) => {
    const { t } = useTranslation()
    const refDynamic = createRef<DynamicRefRef>()
    // const folioComment = props?.folioComment?.evidencesFolios
    const styles = useReportFoliosStyles()
    const [expireData, setExpireData] = useState({
        enable: Boolean(props.defaultData?.enable),
        required: Boolean(props.defaultData?.required),
        description: props.defaultData?.description || t('reportFolio.detail.approve.title'),
        reportFolioIsRequired: Boolean(props.defaultData?.reportFolioIsRequired),
        maxFoliosAmount: props.defaultData?.maxFoliosAmount || '1',
        maxRejectsAmount: props.defaultData?.maxRejectsAmount || '1'
    })
    const existSomeEvidence = props.drawerEvidencesProps.defaultValues?.some(evidence => !!Object.values(evidence ?? {}).length)
    const [actions, setActions] = useState({
        evidence: Boolean(existSomeEvidence),
        // folioManagement: Boolean(Object.values(folioComment?.evidencesData?.[0] ?? {}).length),
    })
    useImperativeHandle(ref, () => ({
        getData: () => {
            const dataForm = refDynamic.current?.getValues()
            return { ...dataForm, ...expireData, }
        },
        activeActions: (payload) => {
            setActions(prev => ({ ...prev, ...payload }))
        },
        activated: actions
    }))

    const folioModel: DynamicFormRefProps['model'] = {
        // reportFolioIsRequired: {
        //     id: 'reportFolioIsRequired',
        //     label: 'El folio de reporte es obligatorio',
        //     name: 'reportFolioIsRequired',
        //     type: 'switch',
        //     wrapper: (payload) => (
        //         <Grid
        //             item
        //             xs={12}
        //             children={(
        //                 <Box>
        //                     {payload.children}

        //                     <Typography sx={styles.rejectError}>{payload?.childrenData?.error ?? ''}</Typography>
        //                 </Box>
        //             )}
        //             key={payload.id}
        //         />
        //     )
        // },
        maxFoliosAmount: {
            id: 'maxFoliosAmount',
            label: t('general.tags.maxReject'),
            name: 'maxFoliosAmount',
            type: 'text',
            validations: { required: { value: true, message: t('general.validations.minFolios') }, number: { value: true }, min: { value: 1 } },
            hiddenError: true,
            wrapper: (payload) => (
                <Grid
                    item
                    xs={6}
                    children={(
                        <Box sx={styles.maxReject}>
                            <Typography className="quest_name_title"># máx. de folios</Typography>

                            <Box>
                                <Box className="w-150">{payload.children}</Box>

                                <Typography sx={styles.rejectError}>{payload?.error ?? ''}</Typography>
                            </Box>
                        </Box>

                    )}
                    key={payload.id}
                />
            )
        },
        maxRejectsAmount: {
            id: 'maxRejectsAmount',
            label: t('general.tags.maxReject'),
            name: 'maxRejectsAmount',
            type: 'text',
            hiddenError: true,
            validations: { required: { value: true, message: t('general.validations.minRejects') }, number: { value: true }, min: { value: 1 } },
            wrapper: (payload) => (
                <Grid
                    item
                    xs={6}
                    children={(
                        <Box sx={styles.maxReject}>
                            <Typography className="quest_name_title"># máx. de rechazos</Typography>

                            <Box>
                                <Box className="w-150">{payload.children}</Box>

                                <Typography sx={styles.rejectError}>{payload?.error ?? ''}</Typography>
                            </Box>
                        </Box>

                    )}
                    key={payload.id}
                />
            )
        },
    }

    const handleActivedActions = ({ name, value, }: { name: 'evidence' | 'reportFolio' | 'folioManagement'; value: boolean }) => {
        setActions(prev => ({ ...prev, [name]: value }))
    }
    useEffect(() => {
        setActions(prev => ({ ...prev, evidence: Boolean(existSomeEvidence) }))
    }, [existSomeEvidence])
    return (
        <>
            <Box sx={styles.container}>
                <Typography className="quest_name_title">{t('Questionarie.settingFolio')}</Typography>

                <Typography sx={[styles.warning, { marginTop: '0px', paddingBottom: '0px' }]}>
                    <span>*</span>
                    {t('Questionarie.order.areaAndDepartment')}
                </Typography>

                <Box sx={styles.containerConfig}>

                    <DynamicFormRef
                        ref={refDynamic}
                        onBlur={(payload) => {
                            const setValue = refDynamic.current?.setValues
                            const name = (payload.current ?? '' as string)
                            const value = payload?.[name]
                            if (['maxFoliosAmount', 'maxRejectsAmount'].includes(name) && !value) {
                                setExpireData(prev => ({ ...prev, [name]: 1 }))
                                setValue({ name, value: 1 })
                            }
                        }}
                        onChange={(payload) => {
                            const name = (payload.current ?? '' as string)
                            const value = payload?.[name]
                            setExpireData(prev => ({ ...prev, [name]: value }))
                        }} parentWrapper={({ children }) => <Grid spacing={2} alignItems='center' container children={children} />}
                        defaultValues={expireData}
                        model={folioModel} />

                    <ClickedBox
                        children={
                            <FormControlLabel
                                sx={{ maxWidth: 'calc(100% - 50px)' }}
                                control={
                                    <IOSSwitch
                                        name="enable"
                                        checked={!!expireData.enable}
                                        onChange={({ target }, checked) => {
                                            const { name } = target
                                            setExpireData(prev => {
                                                let body = ({ ...prev, [name]: checked })

                                                body.required = checked
                                                if (checked) {
                                                    body.description = t('reportFolio.detail.approve.title')
                                                }

                                                return body
                                            })
                                        }}
                                        sx={{ m: 1, }}
                                    />
                                }
                                label={t('reportFolio.setting.enableSurvey')}
                            />
                        }
                        rightChildren={<Radio
                            name="required"
                            checked={!!expireData.required}
                            onClick={() => {
                                setExpireData(prev => ({ ...prev, required: !expireData.required }))
                            }}
                            sx={{ padding: '4px' }}
                        />}
                        active={!!expireData.enable}
                        body={!!expireData.enable ?
                            <TextField
                                label={t(`general.questions.customerSatisfactionQuestion`)}
                                onChange={({ target }) => {
                                    const { value } = target
                                    setExpireData(prev => ({ ...prev, description: value }))
                                }}
                                multiline
                                value={expireData.description}
                                error={!expireData.description}
                                helperText={!expireData.description ? t('general.validations.satisfationQuestionIsRequired') : ''}
                                rows={3}
                            /> : undefined
                        }
                    />

                    <ClickedBox
                        children={(
                            <FormControlLabel
                                control={
                                    <IOSSwitch
                                        checked={actions.evidence}
                                        onChange={(e, value) => {
                                            handleActivedActions({ name: 'evidence', value: value })
                                        }}
                                        sx={{ m: 1 }}
                                    />
                                }
                                label={t('Questionarie.sections.evidenceTypes3')}
                            />
                        )}
                        click={() => {
                            if (props.baseMenuProps.click) {
                                props.baseMenuProps.click({})
                            }
                        }}
                        active={actions.evidence}
                    />

                    <Box sx={styles.footer}>
                        {
                            !props.buttonsDown && (
                                <Button onClick={props.save} variant="contained">{t('general.save')}</Button>
                            )
                        }
                        <Button onClick={props?.removeFolios}>{t('general.cancel')}</Button>
                    </Box>
                </Box>
            </Box>

            <BaseMenu {...props.baseMenuProps} sx={styles.border} />

            <DrawerEvidences
                headerLabel={t('general.returnreportFolioConfig')}
                headerElement={<Typography sx={styles.titleEvidences}>{t('general.folioConfig')}</Typography>}
                optionType={EvidenceOptionType.FOLIO_MANAGEMENT}
                {...props.drawerEvidencesProps}
            />
        </>
    )
})

export { ReportFolio }
